import { TableContainer, Box, Table, TableBody } from '@mui/material'
import { Restriction } from '@/state/bonus-engine/models'
import HeadTableRestrictions from './head.component'

import RowTableRestrictions from './row.component'

type Props = {
  type: 'product' | 'wagerType' | 'sport'
  items: Restriction[]
  listItems: any[]
  handleOnClickSetEnable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDisable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDiscardContribution: (
    type: string,
    value: number | string,
  ) => void
}

const TableRestrictions = ({
  type,
  items,
  listItems,
  handleOnClickSetDisable,
  handleOnClickSetEnable,
  handleOnClickSetDiscardContribution,
}: Props) => {
  return (
    <Box overflow="auto">
      <TableContainer>
        <Table
          className="table-tab table-medium"
          aria-labelledby="tableTitle"
          size="small"
        >
          <HeadTableRestrictions
            type={type}
            handleOnClickSetDisable={handleOnClickSetDisable}
            handleOnClickSetEnable={handleOnClickSetEnable}
          />
          <TableBody>
            {listItems
              .filter((item) => item.isVisible)
              .map((row) => (
                <RowTableRestrictions
                  key={row.name}
                  type={type}
                  row={row}
                  items={items}
                  handleOnClickSetDisable={handleOnClickSetDisable}
                  handleOnClickSetEnable={handleOnClickSetEnable}
                  handleOnClickSetDiscardContribution={
                    handleOnClickSetDiscardContribution
                  }
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TableRestrictions
